
define('text!templates/modules/setting/business/payment/payment-mobile-messages.html',[],function () { return '<span class="sl-icon-exclamation"></span>\n<span>{{#t}}payment:message_mobile_unavailable{{/t}}</span>\n';});

